const API_URL = process.env.REACT_APP_API_URL;

// Get client files
export async function getClientFiles(clientId) {
  const response = await fetch(`${API_URL}/client/${clientId}/fichiers`, {
    method: "GET",
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error("Non authentifié");
  }

  return response.json();
}

// Upload client file
export async function uploadClientFile(clientId, file) {
  const formData = new FormData();
  formData.append("fichier", file);

  const response = await fetch(`${API_URL}/client/${clientId}/fichier`, {
    method: "POST",
    credentials: "include",
    body: formData,
  });

  if (!response.ok) {
    throw new Error("Non authentifié");
  }

  return response.json();
}

// Delete client file
export async function deleteClientFile(clientId, fileId) {
  const response = await fetch(`${API_URL}/client/${clientId}/fichier/${fileId}`, {
    method: "DELETE",
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error("Non authentifié");
  }

  return response.json();
}

// Download client file
export async function downloadClientFile(clientId, fileId, filename) {
  const response = await fetch(
    `${API_URL}/client/${clientId}/fichier/${fileId}/telecharger`,
    {
      method: "GET",
      credentials: "include",
    }
  );

  if (!response.ok) {
    const text = await response.text();
    console.error("Download error:", response.status, text);
    throw new Error("Erreur lors du téléchargement");
  }

  const blob = await response.blob();

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = filename;

  document.body.appendChild(link);
  link.click();
  link.remove();

  window.URL.revokeObjectURL(url);
}

export async function viewClientFile(clientId, fileId) {
  const response = await fetch(`${API_URL}/client/${clientId}/fichier/${fileId}/telecharger`, {
    method: "GET",
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error("Non authentifié");
  }
  const blob = await response.blob();
   const url = window.URL.createObjectURL(blob);
   window.open(url, "_blank");
}